import { z } from "zod";

const optionalText = (max: number, message: string) =>
  z
    .string()
    .trim()
    .max(max, message)
    // `null` et jamais `undefined` : vider un champ doit l'effacer, pas
    // laisser l'ancienne valeur en place.
    .transform((v) => (v === "" ? null : v))
    .nullish()
    .transform((v) => v ?? null);

const isoInstant = z
  .string()
  .trim()
  .refine((v) => !Number.isNaN(Date.parse(v)), "Date et heure attendues");

export const listAppointmentsInput = z
  .object({
    confirmationId: z.string().optional(),
    from: isoInstant,
    to: isoInstant,
  })
  .refine((v) => Date.parse(v.to) > Date.parse(v.from), {
    message: "La fin de la période doit suivre son début",
    path: ["to"],
  });

export const saveAppointmentInput = z.object({
  confirmationId: z.string().optional(),
  /** Absent à la création. */
  id: z.string().uuid().optional(),
  startsAt: isoInstant,
  durationMinutes: z
    .union([z.literal(""), z.null(), z.undefined(), z.coerce.number()])
    .transform((v) => (v === "" || v == null ? null : Math.round(v)))
    .refine((v) => v == null || v > 0, "Une durée doit être positive"),
  kind: z.enum(["visite", "metre", "reception", "livraison", "autre"]).default("autre"),
  title: z.string().trim().min(1, "Dites de quoi il s'agit").max(120, "Intitulé trop long"),
  clientId: z.string().uuid().nullish().transform((v) => v ?? null),
  projectId: z.string().uuid().nullish().transform((v) => v ?? null),
  location: optionalText(200, "Lieu trop long"),
  notes: optionalText(2000, "Notes trop longues"),
});

export const removeAppointmentInput = z.object({
  confirmationId: z.string().optional(),
  id: z.string().uuid("Identifiant de rendez-vous attendu"),
});

export type ListAppointmentsInput = z.infer<typeof listAppointmentsInput>;
export type SaveAppointmentInput = z.infer<typeof saveAppointmentInput>;
export type SaveAppointmentFormInput = z.input<typeof saveAppointmentInput>;
export type RemoveAppointmentInput = z.infer<typeof removeAppointmentInput>;
